import React from 'react';

const Heading = ({ text = 'Heading Text', level = 'h2', align = 'left', className = '' }) => {
  const Tag = level;
  
  const sizeClasses = {
    h1: 'text-4xl md:text-5xl font-bold',
    h2: 'text-3xl md:text-4xl font-bold',
    h3: 'text-2xl md:text-3xl font-semibold',
    h4: 'text-xl md:text-2xl font-semibold',
    h5: 'text-lg md:text-xl font-medium',
    h6: 'text-base md:text-lg font-medium',
  };

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  return (
    <Tag className={`${sizeClasses[level]} ${alignClasses[align]} ${className}`}>
      {text}
    </Tag>
  );
};

Heading.builderConfig = {
  props: {
    text: {
      type: 'text',
      label: 'Heading Text',
      default: 'Heading Text',
    },
    level: {
      type: 'select',
      label: 'Heading Level',
      default: 'h2',
      options: [
        { value: 'h1', label: 'H1' },
        { value: 'h2', label: 'H2' },
        { value: 'h3', label: 'H3' },
        { value: 'h4', label: 'H4' },
        { value: 'h5', label: 'H5' },
        { value: 'h6', label: 'H6' },
      ],
    },
    align: {
      type: 'select',
      label: 'Text Align',
      default: 'left',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
    },
  },
};

export default Heading;
